import usePesquisaGrupoMaterial from "~/fetchs/PriceSearch/usePesquisaGrupoMaterial";
import usePesquisaGruposObrigatorios from "~/fetchs/PriceSearch/usePesquisaGruposObrigatorios";
import useTrilha from "~/fetchs/useTrilha";

const useRequiredGroups = ({
  trilha,
  setRequiredGroupsParams,
  setIsOpenRequiredGroupsModal,
  openModalUpdate,
  pesquisaObjetos,
}) => {
  const { pesquisaGrupoMateriais } = usePesquisaGrupoMaterial();
  const { trilhas } = useTrilha();
  const { pesquisaGruposObrigatoriosObj } = usePesquisaGruposObrigatorios({
    trilhas,
    gruposMateriais: pesquisaGrupoMateriais,
  });

  const groupSearchsByProductGroup = (data) => {
    if (!Array.isArray(data)) {
      return {};
    }

    const searchs = data
      .filter((search) => search.ativo && !search.deletedAt && !search.deletadoEm)
      .map((e) => {
        const pesquisaPlayer = pesquisaObjetos?.pesquisaPlayers?.pesquisaPlayerObjeto["id-" + e.pesquisaPlayerId] ?? "";
        const pesquisaGrupoMaterial =
          pesquisaObjetos.pesquisaGrupoMateriais?.pesquisaGrupoMaterialObjeto["id-" + e.pesquisaGrupoMaterialId];

        return {
          grupoProdutoId: e.pesquisaGrupoMaterialId,
          grupoNome: pesquisaGrupoMaterial?.nome,
          playerId: e.pesquisaPlayerId,
          playerNome: pesquisaPlayer?.nome,
        };
      });

    const groups = searchs.reduce((acc, obj) => {
      const key = `id-${obj.grupoProdutoId}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});

    return groups;
  };

  const verifyRequiredGroups = (data) => {
    const selectedGroups = groupSearchsByProductGroup(data);

    const gruposObrigatorios = pesquisaGruposObrigatoriosObj[trilha];
    let nonSelected = [];
    let shouldOpenModalUpdate = true;

    if (gruposObrigatorios?.gruposObrigatoriosIds?.length > 0) {
      gruposObrigatorios.gruposObrigatoriosIds.map((e) => {
        if (!selectedGroups[`id-${e}`] && gruposObrigatorios?.gruposObrigatorios[`id-${e}`]) {
          nonSelected.push(gruposObrigatorios.gruposObrigatorios[`id-${e}`]);
        }
      });

      if (nonSelected.length > 0) {
        setRequiredGroupsParams((prev) => ({
          ...prev,
          grupos: nonSelected,
        }));

        shouldOpenModalUpdate = false;
      }
    }

    if (shouldOpenModalUpdate) {
      openModalUpdate(true);
    } else {
      setIsOpenRequiredGroupsModal(true);
    }
  };

  return {
    verifyRequiredGroups,
  };
};

export default useRequiredGroups;
